<template>
    <div class='steps'>
        <el-steps :active="stepsActive" simple>
            <el-step title="1、输入抖音号或手机号"></el-step>
            <el-step title="2、获取二维码，并成功扫码"></el-step>
            <el-step title="3、成功扫码后，点击查询，即可获取数据"></el-step>
        </el-steps>

        <!--  第一步 -->
        <div style='padding: 40px;' v-show='stepsActive === 0'>
            <el-input placeholder="请输入内容" v-model="douyin_mark">
                <template slot="prepend">抖音号/手机号</template>
            </el-input>
            <div style='padding-top: 40px; text-align: center;'>
                <el-button type='danger' @click="nextGetQrCode">下一步</el-button>
            </div>
        </div>

        <!-- 第二步 -->
        <div style='padding: 40px;' v-show='stepsActive === 1'>
            <p style='font-size: 26px; text-align: center;'>请先点击获取验号二维码，扫码成功后再查询数据</p>
            <div style='text-align: center; padding: 10px 0;'>
                <el-button type='danger' :loading='qrCodeLoading' @click="getQrCode">获取二维码</el-button>
                <div v-show='qrShow'>
                    <div class='showqrcode flex' style='justify-content: center; padding: 20px 0;'>
                        <div class='qrcode' ref='qrcode' id='qrcode'></div>
                    </div>
                    <div class='qr-status'>
                        <p v-if='+qrStatus === 1'>
                            <i class='el-icon-success' style='color: #888;'></i>
                            <span style='padding-left: 4px;'>待扫码</span>
                        </p>
                        <p v-if='+qrStatus === 2'>
                            <i class='el-icon-success' style='color: #409EFF;'></i>
                            <span style='padding-left: 4px;'>扫码成功</span>
                        </p>
                        <p v-if='+qrStatus === 3'>
                            <i class='el-icon-error' style='color: #f00;'></i>
                            <span style='padding-left: 4px;'>二维码过期</span>
                        </p>
                    </div>
                </div>
            </div>
            <div style='padding-top: 40px; text-align: center;'>
                <el-button @click="stepsActive = 0">返回上一步</el-button>
                <el-button type='danger' @click="nextGetInfo">下一步</el-button>
            </div>
        </div>

        <!-- 第三步 -->
        <div style='padding: 40px;' v-show='stepsActive === 2'>
            <div style='padding-top: 40px; text-align: center;'>
                <el-button type='danger' :loading='infoLoading' @click="getInfo">查询数据</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
    data() {
        return {
            stepsActive: 0,
            douyin_mark: '', // 抖音号
            qrCodeLoading: false,
            infoLoading: false,
            qrShow: false,
            qrStatus: 1, // 1：未扫码，2：扫码成功，3 已经过期
            timer: null, // 定时器的载体
        }
    },
    mounted() {
        this.qrcode('1234567890')
    },
    destroyed() {
        // 如果存在定时器, 则终止定时器
        if (this.timer) {
            clearTimeout(this.timer)
        }
    },
    methods: {
        // 最后一步获取信息
        async getInfo() {
            clearTimeout(this.timer)
            try {
                this.infoLoading = true;
                const res = await this.$fetch('tool/accounts/get-tiktok-data', {
                    douyin_mark: this.douyin_mark,
                    session_id: this.session_id
                }, 'get')

                if (res.code === 0) {
                    this.$emit('updateQueryList', null)
                    this.$emit('getInfo', {
                        douyin_mark: this.douyin_mark,
                        ...res.data,
                    });
                }
            } finally {
                this.infoLoading = false;
            }
        },

        // 下一步获取二维码
        nextGetQrCode() {
            clearTimeout(this.timer)
            if (!this.douyin_mark) {
                this.$message.warning("请输入抖音号")

                return false;
            }

            this.qrShow = false;
            this.stepsActive = 1;
        },

        // 下一步获取详细信息
        nextGetInfo() {
            if (+this.qrStatus !== 2) {
                this.$message.warning("请先进行扫码")

                return false;
            }

            this.stepsActive = 2;
        },

        // 获取二维码
        async getQrCode() {
            const h = this.$createElement;
            this.$msgbox({
                title: '消息',
                message: h('div', null, [
                    h('p', null, '1、获取二维码时，将扣除您的点券；扫码成功后查询时，将不再扣除点券'),
                    h('p', null, '2、部分数据扫码成功后，需等待48小时后才能获取'),
                ]),
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showCancelButton: true,
                type: 'warning'
            }).then(async () => {
                try {
                    this.qrCodeLoading = true;
                    const res = await this.$fetch('/api/proxy/web/tiktokurl', {
                            douyin_mark: this.douyin_mark,
                    }, 'get')

                    if (res.code === 0) {
                        const { session_id, url } = res.data;

                        this.session_id = session_id;
                        this.qrShow = true;
                        this.qrcode(url)
                        await this.qrStatusLoop();
                        this.$emit('updateQrCodeList', null)
                    }
                } finally {
                    this.qrCodeLoading = false;
                }
            }).catch(() => {

            });
        },

        // 开始轮询二维码, 查看状态
        async qrStatusLoop() {
            const requestStatus = async () => {
                try {
                    // this.qrCodeLoading = true;
                    const res = await this.$fetch('tool/accounts/sel-tiktok-stu', {
                        type: 1, // 后端说传字段以作区分
                        session_id: this.session_id,
                    }, 'get')

                    if (res.code === 0) {
                        const { status, url } = res.data;

                        this.qrStatus = status;
                        await this.qrStatusLoop();
                    }
                } finally {
                    // this.qrCodeLoading = false;
                }
            }

            if (+this.qrStatus === 1) {
                this.timer = setTimeout(async () => {
                    await requestStatus();
                }, 3000)
            } else {
                clearTimeout(this.timer)
            }
        },

        // 生成二维码
        qrcode(data) {
            if (this.$refs.qrcode) {
                this.$refs.qrcode.innerHTML = ''
            }

            let qrcode = new QRCode('qrcode', {
                width: 320,
                height: 320,
                text: data,
                // correctLevel : QRCode.CorrectLevel.Q
                // correctLevel: QRCode.CorrectLevel.L
                correctLevel: 3,

            })
            this.$refs.qrcode.removeAttribute('title')
            setTimeout(() => {
                this.$refs.qrcode.removeAttribute('title')
            }, 100)
        },
    }
}
</script>

<style lang='scss'>
.steps {
    .el-step.is-simple:not(:last-of-type) .el-step__title {
        max-width: 70%;

    }
    .el-steps--simple {
        padding: 12px 20px;
        .el-step__title {
            font-size: 14px;
        }
    }
}

</style>
